/**
 * Account Service
 * 
 * Handles account-level operations including deletion via Cloud Functions.
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { safeErrorMessage } from '../utils/sanitize';

/** Extract a human-readable message from an unknown error, falling back to a generic string. */
const extractErrorMessage = (error: unknown): string =>
    error instanceof Error ? error.message : 'Unknown error';

/**
 * Delete a user account and all associated data via Cloud Function.
 * 
 * The Cloud Function handles:
 * 1. Deleting all user's favourites
 * 2. Deleting all user's saved searches
 * 3. Deleting the user document
 * 5. Deleting the Firebase Auth user
 * 
 * @throws Error if the deletion fails
 */
export const deleteUserAccount = async (): Promise<void> => {
    const deleteAccountFn = httpsCallable(functions, 'deleteUserAccount');

    try {
        await deleteAccountFn();
    } catch (error: unknown) {
        console.error('Error deleting user account:', safeErrorMessage(error));
        throw new Error(extractErrorMessage(error));
    }
};
